import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { IBookingCredentialsData } from 'src/app/core/models/booking-credentials.model';
import { PnrInfo } from 'src/app/core/models/itinerary.model';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';
import { RemarksService } from 'src/app/search-result/services/remarks.service';
import { SettingsService } from 'src/app/settings/services/settings.service';
import { LayoutService } from 'src/app/layout/services/layout.service';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {
  IVoidTransactionQuote,
  IVoidTransactionState,
  voidTransactionStates
} from 'src/app/core/models/void-transaction.model';

@Component({
  selector: 'app-void-transaction-modal',
  templateUrl: './void-transaction-modal.component.html',
  styleUrls: ['./void-transaction-modal.component.scss']
})
export class VoidTransactionModalComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isActive: boolean;

  @Output() closeModal = new EventEmitter<boolean>();

  subscriptions = new Subscription();

  loading$: Observable<boolean>;
  state$: Observable<IVoidTransactionState>;

  quoteRequest: IVoidTransactionQuote;
  vtStates = voidTransactionStates;
  restartNeeded: boolean = false;
  formValid: boolean;
  credentialsData: IBookingCredentialsData;
  showModalRemarks: boolean = false;

  constructor(
    private itiService: ItineraryService,
    private settingsService: SettingsService,
    private remarksService: RemarksService,
    private layoutService: LayoutService
  ) {
    this.loading$ = this.itiService.getLoading();
    this.restartNeeded = false;
  }

  ngOnInit(): void {
    this.state$ = this.itiService.getVoidTransactionState();
    this.callComponentSubscriptions();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.isActive.currentValue) {
        this.restartNeeded = false;
      }
    }
  }

  callComponentSubscriptions() {
    this.subscriptions.add(
      this.itiService.getPnrInfo().subscribe((info) => {
        if (info?.code) {
          this.buildQuoteRequest(info);
        }
      })
    );
    this.subscriptions.add(
      this.layoutService.getBookingCredentialsState().subscribe((credentials) => {
        this.credentialsData = credentials.data;
      })
    );
  }

  ValidateNeedRemark() {
    let finalStatus = false;
    this.state$.subscribe((x) => {
      finalStatus = x.currentProccess === this.vtStates.success;
    });
    this.settingsService.getClientSettings().subscribe((settings) => {
      if (settings.requestFinalRemark && finalStatus) {
        this.remarksService
          .getRemarks()
          .pipe(take(1))
          .subscribe((remark) => {
            if (remark) {
              this.closeModal.emit(this.restartNeeded);
            } else {
              this.showModalRemarks = true;
            }
          });
      } else {
        this.closeModal.emit(this.restartNeeded);
      }
    });
  }

  applyVoidTransaction() {
    this.restartNeeded = true;
    this.quoteRequest.overSign = this.credentialsData;
    this.itiService.dispatchVoidTransaction(this.quoteRequest);
  }

  buildQuoteRequest(pnrInfo: PnrInfo) {
    this.quoteRequest = {
      pnr: pnrInfo.code,
      country: pnrInfo.countryCode,
      gds: pnrInfo.gds,
      bookingCode: pnrInfo.code,
      transactionId: pnrInfo.transactionId,
      officeId: pnrInfo.officeId,
      overSign: null,
      receivedFrom: pnrInfo.receivedFrom
    };
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
